import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			communityPlsrInsightsDetailsHeroHeaderCls: string;
		}
	},

	slug: string
}

class Hero extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Community Plsr Insights Details Hero Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.communityPlsrInsightsDetailsHeroHeaderCls || '', 'community_plsr_insights_details_hero', { animCls: 'animate__zoomIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Hero;